import * as React from 'react'
import { useSelector } from 'react-redux'

import './styles.scss'
import ToggleSwitch from './ToggleSwitch'
import { SelectWithLabel } from 'components/Form'
import { emailIntervalOptions } from '../utils'
import { lang } from 'utils/helpers'
import flagEnvDisplay from 'constants/flagEnvDisplay'

const NotificationsDeliveryCard = ({
  delivery,
  emailInterval,
  inChatEmailInterval,
  setChecked,
  handleNotificationsDelivery
}) => {
  const { inchat } = useSelector(store => store.modules)

  const parsedEmailIntervalOptions = emailIntervalOptions.map(({ label, value }) => ({
    label: `${lang('dashboard_every')} ${label} ${lang('dashboard_minutes').toLowerCase()}`,
    value
  }))

  return (
    <div className='notifications-delivery-card'>
      <div className='title-section'>
        <p className='title'>
          {lang('notifications_view_delivery_card_title')}
        </p>
        <p className='subtitle'>
          {lang('notifications_view_delivery_card_subtitle')}
        </p>
      </div>
      <div className='options-section'>
        <div className='options-section__container'>
          <ToggleSwitch
            checked={delivery.email}
            onChange={({ value }) => handleNotificationsDelivery({ field: 'email', value })}
            switchTitle={lang('notifications_view_delivery_card_pool_email_toggle_title')}
            switchSubtitle={lang('notifications_view_delivery_card_email_toggle_subtitle')}
          />
          <SelectWithLabel
            label={lang('dashboard_every')}
            placeholder={lang('dashboard_select')}
            options={parsedEmailIntervalOptions}
            value={parsedEmailIntervalOptions.find(it => it.value === emailInterval)}
            onChange={({ value }) => setChecked({ fieldName: 'emailInterval', fieldValue: value })}
          />
        </div>
        {
          inchat.isActive && flagEnvDisplay.displayInChat ? (
            <div className='options-section__container'>
              <ToggleSwitch
                checked={delivery.inChatEmail}
                onChange={({ value }) => handleNotificationsDelivery({ field: 'inChatEmail', value })}
                switchTitle={lang('notifications_view_delivery_card_inchat_email_toggle_title')}
                switchSubtitle={lang('notifications_view_delivery_card_email_toggle_subtitle')}
              />
              <SelectWithLabel
                label={lang('dashboard_every')}
                placeholder={lang('dashboard_select')}
                options={parsedEmailIntervalOptions}
                value={parsedEmailIntervalOptions.find(el => el.value === inChatEmailInterval)}
                onChange={({ value }) => setChecked({ fieldName: 'inChatEmailInterval', fieldValue: value })}
              />
            </div>
          ) : null
        }
        <ToggleSwitch
          checked={delivery.desktop}
          onChange={({ value }) => handleNotificationsDelivery({ field: 'desktop', value })}
          switchTitle={lang('notifications_view_delivery_card_desktop_toggle_title')}
          switchSubtitle={lang('notifications_view_delivery_card_desktop_toggle_subtitle')}
        />
      </div>
    </div>
  )
}

export default NotificationsDeliveryCard
